import { Dispatch } from "react";
import { Element } from "../models/elementModel";
import { Row } from "../models/rowModel";
import { Section } from "../models/sectionModel";
import { TabModel } from "../models/tabModel";
import { AppState } from "../reducers/rootReducer";
import { AppActions, REMOVE_ELEMENT_LIST, REMOVE_ROW_LIST, REMOVE_SECTION_LIST, REMOVE_TAB_LIST } from "../types/actions";
import rowService from "../services/rowServices";
import sectionService from "../services/sectionService";
import elementService from "../services/elementService";
import tabService from "../services/tabService";
import { removeRowListByFormId } from "./rowListAction";
import { removeSectionListByFormId } from "./sectionListAction";
import { removeElementListByFormId } from "./elementListAction";
import { removeTabListByFormId } from "./tabListAction";

export const removeRowList = (rows: Row[]): AppActions => ({
    type: REMOVE_ROW_LIST,
    rows
});

export const removeSectionList = (sections: Section[]): AppActions => ({
    type: REMOVE_SECTION_LIST,
    sections
});

export const removeElementList = (elements: Element[]): AppActions => ({
    type: REMOVE_ELEMENT_LIST,
    elements
});

export const removeTabList = (tabs: TabModel[]): AppActions => ({
    type: REMOVE_TAB_LIST,
    tabs
});

export const startRemoveByDustbin = (rows: Row[], sections: Section[], elements: Element[], tabs: TabModel[]) => {
    return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        if (rows.length > 0) {
            await rowService.deleteRows(rows);
            dispatch(removeRowList(rows));
        }
        if (sections.length > 0) {
            await sectionService.deleteSections(sections);
            dispatch(removeSectionList(sections));
        }
        if (elements.length > 0) {
            await elementService.deleteElements(elements);
            dispatch(removeElementList(elements));
        }
        if (tabs.length > 0) {
            await tabService.deleteTabs(tabs);
            dispatch(removeTabList(tabs));
        }
    };
};

export const startRemoveByFormIdRedux = (formId : String) => {
    return async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        dispatch(removeRowListByFormId(formId));
        dispatch(removeSectionListByFormId(formId));
        dispatch(removeElementListByFormId(formId));
        dispatch(removeTabListByFormId(formId));
    };
};